module.exports = __webpack_public_path__ + "img/verve.b4293341.svg";